( function( $ ) {
  $( '.__tab_content .__tab a' ).on( 'click', function( e ) {
    e.preventDefault();
    if( ! $( this ).hasClass( '__active' ) ) {
      $( '.__tab a' ).removeClass( '__active' );
      $( this ).addClass( '__active' );

      var tab_index = $( this ).data( 'tab' );

      $( '.__tab_content .__content' ).removeClass( '__active' );
      $( '[data-content="' + tab_index + '"]' ).addClass( '__active' );

      /* Activate the smooth scrolling on mobile view */
      if( $( window ).width() <= 434 ) {
        $( 'html, body' ).animate( {
          scrollTop: $( '.__contents' ).offset().top - 100
        }, 1000 );
      }
    }
  } );
} ) ( jQuery );